import type { IMovementType, IMovementTypeGroup, MovementCounts } from '@/entities/movement-type/types';
import { TMovementType } from '@/entities/movement-type/types';

export function sortAndFilterMovementItems(
  counts: Partial<MovementCounts>,
  movementTypeGroups: IMovementTypeGroup[],
  movementTypes: IMovementType[],
): (IMovementType | IMovementTypeGroup)[] {
  const result: (IMovementType | IMovementTypeGroup)[] = [];
  const usedTypes = new Set<string>();

  // Обработка групп
  movementTypeGroups.forEach((group) => {
    if (
      group.types.some(
        (type) => typeof type === 'string' && type in counts && counts[type as keyof MovementCounts] !== undefined,
      )
    ) {
      result.push({ ...group, isSelected: false });
      group.types.forEach((type) => {
        if (typeof type === 'string') {
          usedTypes.add(type);
        }
      });
    }
  });

  // Обработка отдельных типов
  movementTypes.forEach((type) => {
    if (
      typeof type.str === 'string' &&
      type.str in counts &&
      counts[type.str as keyof MovementCounts] !== undefined &&
      !usedTypes.has(type.str)
    ) {
      result.push({ ...type, isSelected: false });
    }
  });

  // Ранжируем по кол-ву ассортимента (убыв.); у составной группы — сумма её типов
  // (бэк отдаёт только листовые типы, суммы группы в нём нет). other — всегда последним.
  const getCount = (item: IMovementType | IMovementTypeGroup): number => {
    const memberKeys = 'types' in item ? item.types.map(String) : [item.str];

    return memberKeys.reduce((sum, key) => {
      const value = counts[key as keyof MovementCounts];

      return sum + (typeof value === 'number' ? value : 0);
    }, 0);
  };

  result.sort((a, b) => {
    if (a.str === TMovementType.other) {
      return 1;
    }
    if (b.str === TMovementType.other) {
      return -1;
    }

    return getCount(b) - getCount(a);
  });

  return result;
}
